import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { Sidebar } from './Sidebar'
import { InvitoTeamModal } from '../components/InvitoTeamModal'
import { useInviti } from '../hooks/useInviti'
import styles from './AppShell.module.css'

/**
 * Layout principale dell'app. Mostra header, sidebar e il contenuto
 * della rotta corrente. Si occupa anche di proporre all'SDR loggato
 * eventuali inviti team in sospeso al primo accesso della sessione.
 *
 * Logica anti-spam: la modale appare se ci sono inviti, ma se l'utente
 * clicca "Rispondi più tardi" la silenziamo per la sessione corrente
 * via localStorage (chiave = hash degli ID inviti). Cambia la chiave
 * se la lista degli inviti cambia → la modale ricompare appena arriva
 * un invito nuovo.
 */
export function AppShell() {
  const { inviti, haInvitiInAttesa } = useInviti()
  const [mostraModale, setMostraModale] = useState(false)

  // Chiave unica per la lista corrente di inviti. Concatenare gli ID
  // ordinati alfabeticamente garantisce stabilità (l'ordine di arrivo
  // dal backend non influisce).
  const chiaveSilenziata = inviti.length > 0
    ? `inviti-silenziati-${[...inviti.map((i) => i.id)].sort().join('_')}`
    : null

  useEffect(() => {
    if (!haInvitiInAttesa || !chiaveSilenziata) return
    if (localStorage.getItem(chiaveSilenziata)) return
    setMostraModale(true)
  }, [haInvitiInAttesa, chiaveSilenziata])

  const chiudiModale = (): void => {
    if (chiaveSilenziata) localStorage.setItem(chiaveSilenziata, '1')
    setMostraModale(false)
  }

  return (
    <div className={styles.shell}>
      <Header />
      <div className={styles.body}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.container}>
            <Outlet />
          </div>
        </main>
      </div>
      {mostraModale && inviti.length > 0 && (
        <InvitoTeamModal inviti={inviti} onChiudi={chiudiModale} />
      )}
    </div>
  )
}
